import { useQuery } from '@apollo/client';
import type { UseOrganizationsListFetch } from '@openx/components-organization/lib/utils/context/OrganizationHookTypes.ts';
import { GetOrganizationsListDocument } from '../../../graphql/query/organizations/GetOrganizationsList.generated.tsx';

export const useOrganizationsListFetch: UseOrganizationsListFetch = ({ onCompleted, variables, skip }) => {
  const {
    data: { account: organizations } = {},
    error,
    loading,
  } = useQuery(GetOrganizationsListDocument, {
    onCompleted: ({ account_aggregate }) => onCompleted?.(account_aggregate.aggregate?.count),
    variables,
    skip,
  });

  return {
    error,
    loading,
    organizations: organizations ?? [],
  };
};
